export default __webpack_public_path__ + "static/later-board-d4756c5c44e7690e05cab40101b22ce6.webp";